var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.708,
    height: 105,
    viewBox: "0 0 71.708 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e87f38;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multi_user",
    transform: "translate(-162.78 -2084.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_phonelink_24px",
    d: "M11.951,9.976H65.732V4H11.951A5.993,5.993,0,0,0,5.976,9.976V42.842H0v8.963H41.829V42.842H11.951ZM68.72,15.951H50.793a3,3,0,0,0-2.988,2.988V48.817a3,3,0,0,0,2.988,2.988H68.72a3,3,0,0,0,2.988-2.988V18.939A3,3,0,0,0,68.72,15.951Zm-2.988,26.89H53.781V21.927H65.732Z",
    transform: "translate(162.78 2080.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_device_hub_24px",
    d: "M21.65,20.318l-5.329-5.329V10.753a4,4,0,1,0-2.664,0v4.236L8.329,20.318H3v6.661H9.661V22.916l5.329-5.6,5.329,5.6v4.063h6.661V20.318Z",
    transform: "translate(185.094 2120.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_group_24px",
    className: "cls-1",
    d: "M39.3,20.318a7.659,7.659,0,1,0-7.659-7.659A7.627,7.627,0,0,0,39.3,20.318Zm-20.424,0a7.659,7.659,0,1,0-7.659-7.659A7.627,7.627,0,0,0,18.871,20.318Zm0,5.106C12.923,25.424,1,28.411,1,34.36v6.383H36.742V34.36C36.742,28.411,24.82,25.424,18.871,25.424Zm20.424,0c-.74,0-1.583.051-2.476.128,2.961,2.145,5.029,5.029,5.029,8.808v6.383H57.166V34.36C57.166,28.411,45.244,25.424,39.3,25.424Z",
    transform: "translate(170.722 2148.445)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUser);
export default __webpack_public_path__ + "static/media/multi_user.55a0af43481601d522b62bc83425b428.svg";
export { ForwardRef as ReactComponent };